(function ($) {
  DJ.addBehavior('formsInit', '.js-form-wrapper, .media-form', {
    attach: function () {
      const formWrapper = this;
      const radioButtons = formWrapper.querySelectorAll('input[type="radio"]');
      const checkboxes = formWrapper.querySelectorAll('input[type="checkbox"]');
      const select = formWrapper.querySelectorAll('select');
      const file = formWrapper.querySelectorAll('input[type="file"]');
      const dateInputs = formWrapper.querySelectorAll('.js-form-item-date');
      const messageFormInputs = formWrapper.querySelectorAll('.brio-message-form input[type="text"]');

      /**
       * jcf init.
       */
      jcf.replace(radioButtons, 'Radio');
      jcf.replace(checkboxes, 'Checkbox');
      jcf.replace(select, 'Select', {
        wrapNative: false,
        fakeDropInBody: false
      });
      jcf.replace(file, 'File', {
        buttonText: Drupal.t('Parcourir'),
        placeholderText: ''
      });

      /**
       * If radio button with an error, add the error class to its parent.
       */
      if (radioButtons) {
        Array.prototype.slice.call(radioButtons).forEach((radioButton) => {
          if (radioButton.classList.contains('error') && radioButton.parentNode) {
            radioButton.parentNode.classList.add('jcf-error');
          }
        });
      }

      /**
       * If checkbox input with an error, add the error class to its parent.
       */
      if (checkboxes) {
        Array.prototype.slice.call(checkboxes).forEach((checkbox) => {
          if (checkbox.classList.contains('error') && checkbox.parentNode) {
            checkbox.parentNode.classList.add('jcf-error');
          }
        });
      }

      /**
       * If message form text input with an error, add the error class to its parent.
       */
      if (messageFormInputs) {
        Array.prototype.slice.call(messageFormInputs).forEach((messageFormInput) => {
          if (messageFormInput.classList.contains('error')) {
            $(messageFormInput).closest('.form-wrapper').addClass('form-item-with-error');
          }
        });
      }

      /**
       * Date input mask
       * @param element
       *  Date input.
       */
      const dateInputMask = (element) => {
        const inputElement = element;

        inputElement.addEventListener('keypress', (e) => {
          if (e.keyCode < 47 || e.keyCode > 57) {
            e.preventDefault();
          }

          const valueLength = inputElement.value.length;

          // If we're at a particular place, let the user type the slash
          // i.e., 12/1212
          if (valueLength !== 1 || valueLength !== 3) {
            if (e.keyCode === 47) {
              e.preventDefault();
            }
          }

          // If they don't add the slash, do it for them...
          if (valueLength === 2) {
            inputElement.value += '/';
          }
        });
      };

      /**
       * Date input init.
       */
      if (dateInputs) {
        Array.prototype.slice.call(dateInputs).forEach((dateInput) => {
          dateInputMask(dateInput);
        });
      }

      function resizeDatepicker() {
        const bodyWidth = $('body').width();
        if (bodyWidth > 1024) {
          $('.js-date-picker').datepicker({
            format: 'mm/yyyy',
            startView: 'months',
            minViewMode: 'months',
            autoclose: true,
            language: 'fr',
          }).on('show', (el) => {
            const currentTimestamp = el.timeStamp;
            const parentBlock = $(el.currentTarget).parents('.add-resource__col');
            const date = new Date(currentTimestamp);
            const currentYear = date.getFullYear();
            const monthName = date.toLocaleString('default', {
              month: 'short',
            });
            const datePickerYear = parentBlock.find('.datepicker-months .datepicker-switch');
            const months = parentBlock.find('span.month');

            months.each(function () {
              if ($(this).text() === monthName
                && datePickerYear.text() === currentYear.toString()) {
                $(this).addClass('month-highlighted');
              }
            });
          });
        } else {
          $('.js-date-picker').datepicker('remove');
        }

        $(".js-date-picker").on( "input", (e) => {
          setTimeout(() => {
            $(".js-date-picker").datepicker("show");
          }, 100);
        });
      }

      $.fn.datepicker.dates['fr'] = {
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthsShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"],
        today: "Today"
      };

      resizeDatepicker();

      $(window).on('load resize', function (e) {
        resizeDatepicker();
      });

      $(document).ajaxComplete(() => {
        setTimeout(() => {
          const files = formWrapper.querySelectorAll('input[type="file"]');
          jcf.replace(files, 'File', {
            buttonText: Drupal.t('Parcourir'),
            placeholderText: ''
          });
        }, 1);
      });
    }
  });
})(jQuery);
